import React from 'react';
import { usePageSeo } from '../hooks/usePageSeo';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  usePageSeo({ title: 'Page Not Found | Civic Rentals LLC', noindex: true });

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
            <img
              src="/logo.png"
              alt="Civic Rentals LLC Logo"
              className="h-10 w-auto object-contain"
            />
            <span className="text-2xl font-bold text-slate-900">Civic Rentals LLC</span>
          </div>
        </div>
      </header>
      <div className="flex-1 flex items-center justify-center px-6 pt-20">
        <div className="text-center space-y-6 max-w-lg">
          <h1 className="text-6xl font-bold text-slate-900" data-testid="404-heading">404</h1>
          <p className="text-xl text-slate-600">The page you're looking for doesn't exist or has been moved.</p>
          <Button
            onClick={() => navigate('/')}
            size="lg"
            className="gap-2"
            data-testid="404-home-btn"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
